import { createSelector } from 'reselect'

const emptyObject = {}

export const getPreloadedAppLocation = createSelector(
  [(state) => state.initialAppLocation],
  (appLocation) => appLocation || emptyObject,
)
